//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const DeferDisplayIfOtherHasValueRendering: FeatureFlag = {"Id":"DeferDisplayIfOtherHasValueRendering","Label":"[10.18]Defer DisplayIfOtherHasValue rendering","Impact":"Delay rendering DisplayIfOtherHasValue children until they are visible at least once.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
